import packageJson from '../package.json';

export type ConfigValue = {
  appName: string;
  appVersion: string;
  serverUrl: string;
  localApiUrl: string;
  assetsDir: string;
  tokenEncryptSecretKey: string;
  isStaticExport: boolean;
  appUrl: string;
};

export const CONFIG: ConfigValue = {
  appName: 'Seller Sos',
  appVersion: packageJson.version,
  serverUrl: process.env.NEXT_PUBLIC_SERVER_URL ?? '',
  localApiUrl: process.env.NEXT_LOCAL_SERVER_URL ?? '',
  assetsDir: process.env.NEXT_PUBLIC_ASSETS_DIR ?? '',
  tokenEncryptSecretKey: process.env.NEXT_PUBLIC_TOKEN_ENCRYPT_SECRET_KEY ?? '',
  isStaticExport: JSON.parse(`${process.env.BUILD_STATIC_EXPORT}`),
  appUrl: process.env.NEXT_PUBLIC_APP_URL ?? '',
};
